import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const isJa = i18n.language === 'ja';

  const toggle = () => {
    const next = isJa ? 'en' : 'ja';
    i18n.changeLanguage(next);
    localStorage.setItem('lang', next);
  };

  return (
    <button
      onClick={toggle}
      className="px-2 py-1 rounded-lg text-xs font-bold transition-colors text-gray-300 hover:text-white hover:bg-white/10 border border-gray-600"
      title={isJa ? 'Switch to English' : '日本語に切り替え'}
    >
      {isJa ? 'EN' : 'JP'}
    </button>
  );
}
